import React from "react";
import cash_delivery from "../assets/images/cash-delivery.png";

// Two payment options only:
//   - Cash (COD for delivery / COP for pickup)
//   - Pay with Card → handled by Checkout.com Flow on the /pay page (no card saving)
const PaymentSection = ({ activeTab, paymentMethod, setPaymentMethod }) => {
  const cashMethod = activeTab === "pickup" ? "COP" : "COD";
  const cashLabel = activeTab === "pickup" ? "Cash On Pickup" : "Cash On Delivery";

  return (
    <div className="payment-methods p-3 mx-2">
      <h5 className="mt-2">Payment Methods</h5>

      <div className="methods">
        {/* Cash */}
        <div className="cash-delivery row border-bottom">
          <div className="col-11">
            <img src={cash_delivery} alt={cashMethod} /> <span>{cashLabel}</span>
          </div>
          <div className="col-1">
            <input
              type="checkbox"
              className="checkbox cart-checkbox"
              onClick={() => setPaymentMethod(cashMethod)}
              checked={paymentMethod === cashMethod}
              readOnly
            />
          </div>
        </div>

        {/* Pay with card via Checkout Flow */}
        <div className="cash-delivery row border-bottom">
          <div className="col-11">
            <i className="bi bi-credit-card-2-front me-2"></i>
            <span>Pay with Card</span>
          </div>
          <div className="col-1">
            <input
              type="checkbox"
              className="checkbox cart-checkbox"
              checked={paymentMethod === "Card"}
              onClick={() => setPaymentMethod("Card")}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSection;
